import styled from 'styled-components'
import Typography from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { foldableSectionMixin } from '../Section'

export const Container = styled.div`
  margin-bottom: 40px;
  ${foldableSectionMixin};
  position: relative;

  padding: 20px 36px;

  ${Media.Phone`
    padding: 21px 20px;
  `};
`

export const SectionTitle = styled.div`
  ${Typography.Subhead}
  font-weight: 600;
  margin-bottom: 12px;
`

export const SectionContent = styled.div``
